/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { useEffectOnce } from 'react-use';
import InputDollar from '../../InputDollar/InputDollarView';
import InputPercentage from '../../InputPercentage/InputPercentageView';
import SimpleSelect from '../../SimpleSelect/SimpleSelectView';
import { TaxStatusDTO } from '../../../Profile/Accounts/api/useAccountsQuery';

enum BalancesUnit {
  Dollar,
  Percentage,
}

export const RothBalances = ({ account, updateAccount, accountTypes }) => {
  useEffectOnce(() => {
    if (!account.Balances?.Unit) {
      updateAccount({ Balances: { Unit: BalancesUnit.Dollar } });
    }
  });

  const accountTypeOptions = accountTypes.find(t => t.AccountType === account.AccountType);

  const taxStatusOptions =
    accountTypeOptions?.BalanceTaxStatuses.map(({ Label, Value }) => ({
      label: Label,
      value: Value,
    })) ?? [];

  const balanceTaxStatusesOptions =
    accountTypeOptions?.BalanceTaxStatuses.filter(({ Value }) => Value !== TaxStatusDTO.Mix).map(
      ({ Value }) => Value,
    ) ?? [];

  return (
    <>
      {taxStatusOptions.length > 0 && (
        <li className="form-input" style={{ display: 'block' }}>
          <SimpleSelect
            placeholder="Tax Status"
            id="adv-tax-status"
            className="no-horizontal-scroll sm"
            value={taxStatusOptions.find(t => t.value === account.TaxStatus)}
            options={taxStatusOptions}
            isLeftAligned
            onValueChange={opt => updateAccount({ TaxStatus: opt.value })}
          />
        </li>
      )}

      {[TaxStatusDTO.Mix].includes(account.TaxStatus) && (
        <li className="form-input contribuion" style={{ display: 'block' }}>
          <ul className="horizontal school-list contributions-period-list">
            <li className="school-item radio">
              <div
                onClick={() =>
                  updateAccount({
                    Balances: {
                      Unit: BalancesUnit.Dollar,
                      AfterTax: { NonSpecificPositionsValue: '' },
                      PreTax: { NonSpecificPositionsValue: '' },
                      Roth: { NonSpecificPositionsValue: '' },
                    },
                  })
                }
              >
                <div
                  className={`school-item__button-radio-empty ${
                    account.Balances?.Unit === BalancesUnit.Dollar ? 'selected' : ''
                  }`}
                />
                <button type="button" className="school-item__button small">
                  $
                </button>
              </div>
            </li>
            <li className="school-item radio">
              <div
                onClick={() =>
                  updateAccount({
                    Balances: {
                      Unit: BalancesUnit.Percentage,
                      AfterTax: { NonSpecificPositionsValue: '' },
                      PreTax: { NonSpecificPositionsValue: '' },
                      Roth: { NonSpecificPositionsValue: '' },
                    },
                  })
                }
              >
                <div
                  className={`school-item__button-radio-empty ${
                    account.Balances?.Unit === BalancesUnit.Percentage ? 'selected' : ''
                  }`}
                />
                <button type="button" className="school-item__button small">
                  %
                </button>
              </div>
            </li>
          </ul>
        </li>
      )}

      {/* Roth */}
      {[TaxStatusDTO.Mix].includes(account.TaxStatus) &&
        balanceTaxStatusesOptions.includes(TaxStatusDTO.Roth) && (
          <>
            <li className="form-input">
              <div className="contribution-type">
                {account.Balances?.Unit === BalancesUnit.Dollar && (
                  <InputDollar
                    maxLength="256"
                    placeholder="Roth"
                    id="adv-roth"
                    className="accounts"
                    isLeftAligned
                    value={account.Balances?.Roth?.NonSpecificPositionsValue}
                    onChange={({ target: { value } }) =>
                      updateAccount({ Balances: { Roth: { NonSpecificPositionsValue: value } } })
                    }
                  />
                )}
                {account.Balances?.Unit === BalancesUnit.Percentage && (
                  <InputPercentage
                    placeholder="Roth"
                    id="adv-roth"
                    maxLength="256"
                    numDecimals={0}
                    className="accounts"
                    isLeftAligned
                    value={account.Balances?.Roth?.NonSpecificPositionsValue}
                    onChange={({ target: { value } }) =>
                      updateAccount({ Balances: { Roth: { NonSpecificPositionsValue: value } } })
                    }
                  />
                )}
              </div>
            </li>
          </>
        )}

      {/* PreTax */}
      {[TaxStatusDTO.Mix].includes(account.TaxStatus) &&
        balanceTaxStatusesOptions.includes(TaxStatusDTO.PreTax) && (
          <>
            <li className="form-input">
              <div className="contribution-type">
                {account.Balances?.Unit === BalancesUnit.Dollar && (
                  <InputDollar
                    maxLength="256"
                    placeholder="Pre Tax"
                    id="adv-pre-tax"
                    className="accounts"
                    isLeftAligned
                    value={account.Balances?.PreTax?.NonSpecificPositionsValue}
                    onChange={({ target: { value } }) =>
                      updateAccount({ Balances: { PreTax: { NonSpecificPositionsValue: value } } })
                    }
                  />
                )}
                {account.Balances?.Unit === BalancesUnit.Percentage && (
                  <InputPercentage
                    placeholder="Pre Tax"
                    id="adv-pre-tax"
                    maxLength="256"
                    numDecimals={0}
                    className="accounts"
                    isLeftAligned
                    value={account.Balances?.PreTax?.NonSpecificPositionsValue}
                    onChange={({ target: { value } }) =>
                      updateAccount({ Balances: { PreTax: { NonSpecificPositionsValue: value } } })
                    }
                  />
                )}
              </div>
            </li>
          </>
        )}

      {/* AfterTax */}
      {[TaxStatusDTO.Mix].includes(account.TaxStatus) &&
        balanceTaxStatusesOptions.includes(TaxStatusDTO.AfterTax) &&
        taxStatusOptions.some(opt => opt.value === TaxStatusDTO.AfterTax) && (
          <>
            <li className="form-input">
              <div className="contribution-type">
                {account.Balances?.Unit === BalancesUnit.Dollar && (
                  <InputDollar
                    maxLength="256"
                    placeholder="After Tax"
                    id="adv-after-tax"
                    className="accounts"
                    isLeftAligned
                    value={account.Balances?.AfterTax?.NonSpecificPositionsValue}
                    onChange={({ target: { value } }) =>
                      updateAccount({
                        Balances: { AfterTax: { NonSpecificPositionsValue: value } },
                      })
                    }
                  />
                )}
                {account.Balances?.Unit === BalancesUnit.Percentage && (
                  <InputPercentage
                    placeholder="After Tax"
                    id="adv-after-tax"
                    maxLength="256"
                    numDecimals={0}
                    className="accounts"
                    isLeftAligned
                    value={account.Balances?.AfterTax?.NonSpecificPositionsValue}
                    onChange={({ target: { value } }) =>
                      updateAccount({
                        Balances: { AfterTax: { NonSpecificPositionsValue: value } },
                      })
                    }
                  />
                )}
              </div>
            </li>
          </>
        )}
    </>
  );
};
